export default __webpack_public_path__ + "static/media/logomark.3d058f60.png";